import { IObservable } from '~/rage/utils';
import { ClothesComponentId } from '~/shared';
import { RpcService } from '../RpcService';
import { VarsService } from '../VarsService';
import { IClothesTesterService, IComponent } from './clothesTesterServiceTypes';

export class ClothesTesterService implements IClothesTesterService {
	private initialComponents: Partial<Record<ClothesComponentId, IComponent>> =
		{};

	constructor(
		private readonly rpc: RpcService,
		private readonly vars: VarsService,
	) {
		for (let i = 0; i <= ClothesComponentId.BRACELETS; i++) {
			this.initialComponents[i as ClothesComponentId] = {
				drawable: 0,
				texture: 0,
			};
		}
	}

	public async getComponentDrawablesCount(
		componentId: number,
	): Promise<number> {
		if (componentId >= ClothesComponentId.HATS) {
			return this.rpc.invokeClient('clothesTester:getPropDrawablesCount', {
				componentId: componentId - ClothesComponentId.HATS,
			});
		} else {
			return this.rpc.invokeClient('clothesTester:getComponentDrawablesCount', {
				componentId,
			});
		}
	}

	public async getComponentTexturesCount(
		componentId: number,
		drawableId: number,
	): Promise<number> {
		if (componentId >= ClothesComponentId.HATS) {
			return this.rpc.invokeClient('clothesTester:getPropTexturesCount', {
				componentId: componentId - ClothesComponentId.HATS,
				drawableId,
			});
		} else {
			return this.rpc.invokeClient('clothesTester:getComponentTexturesCount', {
				componentId,
				drawableId,
			});
		}
	}

	public getComponents(): IObservable<Record<ClothesComponentId, IComponent>> {
		return this.vars.get(
			'clothesTester:components',
			this.initialComponents as Record<ClothesComponentId, IComponent>,
		);
	}

	public async applyComponents(
		componentId: number,
		drawableId: number,
		textureId: number,
		torsoDrawableId: number,
		torsoTextureId: number,
		undershirtDrawableId: number,
		undershirtTextureId: number,
		isHatHidden: boolean,
		areGlassesHidden: boolean,
		isBellyOpen: boolean,
	): Promise<void> {
		return this.rpc.invokeServer('clothesTester:applyComponents', {
			componentId,
			drawableId,
			textureId,
			torsoDrawableId,
			torsoTextureId,
			undershirtDrawableId,
			undershirtTextureId,
			isHatHidden,
			areGlassesHidden,
			isBellyOpen,
		});
	}

	public async lookAtComponent(componentId: ClothesComponentId): Promise<void> {
		return this.rpc.invokeClient('clothesTester:lookAtComponent', {
			componentId,
		});
	}

	public async exit(): Promise<void> {
		return this.rpc.invokeClient('clothesTester:exit');
	}
}
